import { render, staticRenderFns } from "./OfficialTag.vue?vue&type=template&id=06e6e792&scoped=true"
import script from "./OfficialTag.vue?vue&type=script&lang=js"
export * from "./OfficialTag.vue?vue&type=script&lang=js"
import style0 from "./OfficialTag.vue?vue&type=style&index=0&id=06e6e792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6e792",
  null
  
)

export default component.exports